import { apiFetch, isWhitespaceString } from '@ami/react/core';
import { UserFilter } from './userFilter';

const _baseEndPoint = 'users';

export class User {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.userId = item.userId;
      this.fullName = item.fullName;
      this.email = item.email;
      this.password = item.password;
      this.phoneNumber = item.phoneNumber;
      this.roleIds = item.roleIds;
      this.roleNames = item.roleNames;
      this.enabledEmailTemplateTypes = item.enabledEmailTemplateTypes || [];
      this.label = item.fullName; // Used in dropdowns.
      return;
    }
    this.id = null;
    this.userId = null;
    this.fullName = '';
    this.email = '';
    this.password = '';
    this.phoneNumber = '';
    this.roleIds = [];
    this.roleNames = [];
    this.enabledEmailTemplateTypes = [];
  }

  static async search(filter = new UserFilter(), page) {
    if (isWhitespaceString(filter.search))
      filter.search = null;

    filter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    return result.map((x) => new User(x));
  }

  static getById(id) {
    return apiFetch(`${_baseEndPoint}/${id}`).then((x) =>
      Promise.resolve(new User(x))
    );
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }

  static getAvailableEmailTemplateTypes() {
    return apiFetch(`${_baseEndPoint}/email-template-types`);
  }
}
